import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DettaglioArticoloDipendenteService } from 'src/app/shared/services/dettaglio-articolo-dipendente.service';
import { DipendentiArticoliDettaglio } from 'src/app/models/dipendenti-articoli-dettaglio';
import { ArticoliPrevistiByDipendenteComponent } from '../articoli-previsti-by-dipendente/articoli-previsti-by-dipendente.component';
import { DettaglioMovimento } from 'src/app/models/dettaglio-movimento';
import { TipiArticoliAssegnatiByMansioneComponent } from '../tipi-articoli-assegnati-by-mansione/tipi-articoli-assegnati-by-mansione.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-gestione-articoli-previsti',
  templateUrl: './gestione-articoli-previsti.component.html',
  styleUrls: ['./gestione-articoli-previsti.component.scss'],
  imports: [
    TipiArticoliAssegnatiByMansioneComponent,
    ArticoliPrevistiByDipendenteComponent,
  ],
  standalone: true,
})
export class GestioneArticoliPrevistiComponent implements OnChanges {
  private dettArtDipService = inject(DettaglioArticoloDipendenteService);
  @Input() idDipendente: number = 0;
  @Input() idMansione: number = 0;
  @Input() bConsultazione: boolean = false;
  @Input() listDettaglio: DettaglioMovimento[] = [];

  listDetArtDip: DipendentiArticoliDettaglio[] = [];

  listDettaglioBS = new BehaviorSubject<DettaglioMovimento[]>([]);

  tipoFiltro = 'M';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['idDipendente']) {
      const idDip = changes['idDipendente'].currentValue;
      if (idDip && idDip > 0) {
        //this.loadDettaglioArticoliDipendente();
      }
    }
  }

  loadDettaglioArticoliDipendente() {
    this.dettArtDipService
      .listByDipendente(this.idDipendente)
      .subscribe((dati) => {
        this.listDetArtDip = dati;
      });
  }

  caricaLista(e: DipendentiArticoliDettaglio[]) {
    this.listDetArtDip = e;
  }
}
